import { IPM } from "~/telemetry/background";
import { port } from "../../../../adblockplusui/adblockpluschrome/lib/messaging/port";
import { Prefs } from "~/alias/prefs";
export function start() {
    port.on("testing.ping_ipm_server", async () => {
        await Prefs.untilLoaded;
        return await IPM.pingNow();
    });
}
